import {
    Component,
    OnInit,
    SimpleChanges,
    Optional,
    Inject,
    Input
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Location } from '@angular/common';
import {
    FormGroup,
    FormBuilder,
    FormControl,
    Validators
} from '@angular/forms';
import * as moment from 'moment';
@Component({
    selector: 'app-select-payment',
    templateUrl: './select-payment.component.html',
    styleUrls: ['./select-payment.component.scss']
})
export class SelectPaymentComponent implements OnInit {
    @Input() title: string;
    isModal: boolean;
    form: FormGroup;
    showForm: boolean;
    inputData: any;
    useCredit: boolean;
    showCreditBlock: boolean;
    credit: number;
    residualCredit: number;

    totalPrice: number;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) data,
        @Optional() private dialogRef: MatDialogRef<SelectPaymentComponent>,
        private location: Location,
        private fb: FormBuilder
    ) {
        this.useCredit = false;
        if (data) {
            this.isModal = true;
            this.title = data.title;
            this.inputData = data;
            this.checkCredit();
        } else {
            this.isModal = false;
        }
        this.buildForm();
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnChanges(changes: SimpleChanges): void {}

    checkCredit() {
        if (this.inputData.student) {
            const check = this.inputData.student.creditExpireDate;
            let expireDate = null;
            if (check) {
                expireDate = moment(check).valueOf();
            }
            let today: any = new Date();
            today = moment(today).valueOf();
            const isWaitingForPayment = this.setStudentCredit();
            if (expireDate && expireDate > today) {
                if (this.credit && this.credit > 0) {
                    this.useCredit = true;
                    this.totalPrice =
                        this.inputData.purchasedSalesPackage.price -
                        this.credit;
                    if (!isWaitingForPayment) {
                        this.residualCredit =
                            this.inputData.student.credit - this.credit;
                    } else {
                        let tp = this.totalPrice;
                        if (tp < 0) {
                            tp = tp * -1;
                        }
                        this.residualCredit = tp;
                    }
                    this.showCreditBlock = true;
                } else {
                    this.useCredit = false;
                    this.totalPrice = this.inputData.purchasedSalesPackage.price;
                    this.showCreditBlock = false;
                }
                if (this.totalPrice <= 0) {
                    this.totalPrice = 0;
                }
            } else {
                this.useCredit = false;
                this.totalPrice = this.inputData.purchasedSalesPackage.price;
            }
        }
    }

    setStudentCredit() {
        const psLastEvent = this.inputData.purchasedSalesPackage.lastEvent;
        let c,
            ret = false;
        if (psLastEvent) {
            switch (psLastEvent.eventName) {
                case 'WAITING_FOR_PAYMENT':
                    c = this.inputData.student.credit;
                    ret = true;
                    break;
                case 'ERROR':
                    if (
                        psLastEvent.prevEventName === 'STUDENT_ATTEMPT_TO_PAY'
                    ) {
                        c = this.inputData.purchasedSalesPackage.creditApplied;
                    }
                    break;
                case 'STUDENT_ATTEMPT_TO_PAY':
                    c = this.inputData.purchasedSalesPackage.creditApplied;
                    break;
                default:
                    break;
            }
        }
        this.credit = c;
        return ret;
    }

    async ngOnInit() {}

    buildForm() {
        this.form = this.fb.group({
            paymentType: new FormControl('PAYPAL', Validators.required)
        });
        this.showForm = true;
    }

    okCallback(paymentType) {
        console.log(paymentType);
    }

    goBack() {
        this.location.back(); // viene fruito sempre in modale
    }

    nextStep(value) {
        if (this.isModal) {
            this.inputData.okCallback(value, this.useCredit);
        } else {
            console.log(value);
        }
    }

    cancelBtn() {
        if (this.isModal) {
            this.inputData.nokCallback();
        } else {
            this.goBack(); // viene fruito sempre in modale
        }
    }
}
